import type { Action } from 'redux';
import dash_api from '../../../../../../main/support/dash_api';
import type { LinkIds } from '../../../../../../main/types/googleTypes';
import { ReduxAsyncAction } from '../../../../../services/ReduxAsyncAction';
import type { ValidateGoogleLinkIdsPayload } from '../GoogleAds.types';

const ValidateGoogleAdsLinkIds = new ReduxAsyncAction<'VALIDATE_GOOGLE_ADS_LINK_IDS', LinkIds, ValidateGoogleLinkIdsPayload>(
  'VALIDATE_GOOGLE_ADS_LINK_IDS'
);
ValidateGoogleAdsLinkIds.registerRequest((linkIdsToValidate: LinkIds) => {
  return dash_api
    .post(`/v1/san-onboarding-validation/google`, {
      link_ids: linkIdsToValidate,
    })
    .then(({ data }) => {
      return data;
    });
});
export const VALIDATE_GOOGLE_ADS_LINK_IDS = ValidateGoogleAdsLinkIds.actionNamespaceConstants;
export const validateGoogleAdsLinkIds = ValidateGoogleAdsLinkIds.request;

export type ValidateGoogleLinkIdsAction = Action<
  typeof VALIDATE_GOOGLE_ADS_LINK_IDS.response | typeof VALIDATE_GOOGLE_ADS_LINK_IDS.request
> & {
  data?: ValidateGoogleLinkIdsPayload;
};
